import { ReactNode } from 'react';
import './StatisticsGrid.scss'

interface IStatisticsGridProps {
  children?: ReactNode | ReactNode[];
}

const StatisticsGrid = ({ children }: IStatisticsGridProps) => {
  return <div className='statistics-grid'>{children}</div>;
};

export default StatisticsGrid;
